module.exports = __webpack_public_path__ + "img/deposit.455e421e.svg";